import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { CraeteTitleCmsrDTO, ShopApiService } from 'features/shop-item/api/shop-api.service';
import { queryClient } from 'providers';


const { createDelivery } = ShopApiService();

export const useCreateDelivery = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteTitleCmsrDTO) => {
            return createDelivery(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Delivery has been created successfully!!");
            },
        },
    );
};
